import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import z from "zod";

import { type GetGlobalStatisticsRequestQuery } from "../types";
import { IN_HOME_APP_EVENTS } from "./events";

// The BFF contract is not up to date with the actual return value
// Given the HH deprioritzation, we need to use this type for the time being.
const getGlobalStatisticsResponse = z.object({
  data: z.object({
    attributes: z.object({
      openVisitsCount: z.number(),
      bookedVisits: z.number(),
      openCasesCount: z.number(),
    }),
  }),
});

type GetGlobalStatisticsResponse = z.infer<typeof getGlobalStatisticsResponse>;

export function buildWorkerStatisticsUrl(workerId: string) {
  return `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/in-home/workers/${workerId}/global-statistics`;
}

export function useInHomeStatistics(
  filters: GetGlobalStatisticsRequestQuery,
  workerId: string,
  options: UseGetQueryOptions<GetGlobalStatisticsResponse> = {}
) {
  const filtersWithDefaults = {
    ...filters,
    filter: { booked: false, status: "OPEN", ...filters.filter },
  };

  const url = buildWorkerStatisticsUrl(workerId);

  return useGetQuery({
    url,
    queryParams: filtersWithDefaults,
    responseSchema: getGlobalStatisticsResponse,
    meta: {
      logErrorMessage: IN_HOME_APP_EVENTS.GET_WORKER_STATISTICS_FAILURE,
    },
    retry: 0,
    staleTime: 1000 * 60 * 10,
    refetchInterval: 1000 * 60 * 10,
    ...options,
  });
}
